import { Card, Skeleton, Stack } from "@mui/material";

export default function FinalReportSummaryCardSkeleton() {
    return (
        <Card component={Stack} padding={2} gap={2} variant="outlined">
            <Skeleton variant="text" width="30%" height={32} />
            <Skeleton variant="rectangular" height={110} />
        </Card>
    );
}
